import { useSelector } from "react-redux";
import { AppState } from "../../../core/app/AppReducer";
import DekuStick from "../../../core/assets/oot/gshd/sticks_32x32.png";
import Item from "../../../core/items/Item";
import OotItem from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";


const DekuStickItem = () => {

    let id = "OoT_DekuStick";


    let reduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)

    if (reduce)
        return null;
    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={DekuStick} title="Deku Stick" updateItem={updateOotItem} item={item} />
        }}
    </OotItem>
}

export default DekuStickItem;

export const SimpleDekuStickItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={DekuStick}
        onClick={props.onClick}
        name="Deku Stick"
    />


}